import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Scroll from 'react-scroll';
import { useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers, faTasks, faTachometer, faPlus, faEye, faPencil, faVideo, faCheckCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import { useRecoilState } from 'recoil';

import { topAlertMessageState, topAlertStatusState, userDetailState } from "../../../../AppState";
import { putSessionUpdateAPI } from "../../../../API/Session";
import { getSessionDetailAPI } from "../../../../API/Session";
import FormErrorBox from "../../../Reusable/FormErrorBox";
import FormInputField from "../../../Reusable/FormInputField";
import FormTextareaField from "../../../Reusable/FormTextareaField";
import FormMultiSelectField from "../../../Reusable/FormMultiSelectField";
import PageLoadingContent from "../../../Reusable/PageLoadingContent";


function UserSessionVideoSectionExerciseUpdate() {
    ////
    //// URL parameters.
    ////

    const { uid, sid, vsid } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);
    const [user, setUser] = useRecoilState(userDetailState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [isFetching, setFetching] = useState(false);
    const [forceURL, setForceURL] = useState("");
    const [session, setSession] = useState({});
    const [name, setName] = useState();
    const [detail, setDetail] = useState();

    ////
    //// Event handling.
    ////

    const onSubmitClick = (e) => {
        console.log("onSubmitClick: Beginning...");
        const modifiedVideoSection = {
            name: name,
            detail: detail,
        };
        console.log("onSubmitClick: Updating to video sections array...");
        for (let videoSectionIndex in session.videoSections) {
            if (videoSectionIndex === vsid) {
                session.videoSections[videoSectionIndex] = modifiedVideoSection;
            }
        }

        console.log("onSubmitClick: Payload:", session);

        console.log("onSubmitClick: Please wait");
        putSessionUpdateAPI(session, onSessionUpdateSuccess, onSessionUpdateError, onSessionUpdateDone);
    }

    ////
    //// API.
    ////

    // --- Detail --- //

    function onSessionDetailSuccess(response){
        console.log("onSessionDetailSuccess: Starting...");
        console.log("onSessionDetailSuccess: session data:", response);
        setSession(response);

        for (let videoSectionIndex in response.videoSections) {
            if (videoSectionIndex === vsid) {
                let videoSection = response.videoSections[videoSectionIndex];

                console.log("Matched Video Section", videoSection);
                setName(videoSection.name);
                setDetail(videoSection.detail);
            }
        }
    }

    function onSessionDetailError(apiErr) {
        console.log("onSessionDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionDetailDone() {
        console.log("onSessionDetailDone: Starting...");
        setFetching(false);
    }

    // --- Update --- //

    function onSessionUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Video section updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Redirect the user to a new page.
        setForceURL("/user/" + uid + "/session/" + sid + "/video-section/" + vsid);
    }

    function onSessionUpdateError(apiErr) {
        console.log("onSessionUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionUpdateError: Delayed for 2 seconds.");
            console.log("onSessionUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();

        // Reload the session template upon errors.
        setFetching(true);
        getSessionDetailAPI(
            sid,
            onSessionDetailSuccess,
            onSessionDetailError,
            onSessionDetailDone
        );
    }

    function onSessionUpdateDone() {
        console.log("onSessionUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionDetailAPI(
                sid,
                onSessionDetailSuccess,
                onSessionDetailError,
                onSessionDetailDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/users" aria-current="page"><FontAwesomeIcon className="fas" icon={faUsers} />&nbsp;Users</Link></li>
                            <li class=""><Link to={`/user/${uid}/sessions`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Sessions)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Video Sections)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Update</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Video Section</Link></li>
                        </ul>
                    </nav>

                    {/* Page */}
                    <nav class="box">
                        <p class="title is-4"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section - {user.firstName} {user.lastName}</p>
                        <FormErrorBox errors={errors} />

                        <p class="subtitle is-6">Details</p>

                        {isFetching && <PageLoadingContent displayMessage={"Please wait"} />}

                        {!isFetching && <div class="container">
                            <FormInputField
                                label="Name"
                                name="name"
                                type="text"
                                placeholder="Text input"
                                value={name}
                                errorText={errors && errors.name}
                                helpText=""
                                onChange={(e)=>setName(e.target.value)}
                                isRequired={true}
                                maxWidth="185px"
                            />

                            <FormInputField
                                label="Detail"
                                name="detail"
                                type="text"
                                placeholder="Text input"
                                value={detail}
                                errorText={errors && errors.detail}
                                helpText=""
                                onChange={(e)=>setDetail(e.target.value)}
                                isRequired={true}
                                maxWidth="375px"
                            />

                            <div class="columns">
                                <div class="column is-half">
                                    <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}`} class="button is-hidden-touch"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                    <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}`} class="button is-fullwidth is-hidden-desktop"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                </div>
                                <div class="column is-half has-text-right">
                                    <button class="button is-primary is-hidden-touch" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                    <button class="button is-primary is-fullwidth is-hidden-desktop" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                </div>
                            </div>

                        </div>}
                    </nav>
                </section>
            </div>
        </>
    );
}

export default UserSessionVideoSectionExerciseUpdate;
